export default "__VITE_ASSET__XyUo8Gcf__"